/** The Admin place's eight tabs, and which served section lives on which (KD, 2026-11-01).
 *
 * Its own module so the screen file exports only the screen (React refresh) and so the screen test
 * can name the same mapping the screen uses instead of copying it. The keys are the `?tab=` values
 * `routeTable.ts` gives the Admin tabs (the first, People and roles, carries no parameter), and a test
 * keeps the two lists equal.
 *
 * **Grouped by the question an administrator arrives with**: who is here and what they may do (People
 * and roles), who must agree before a figure counts (Approval routes), how people sign in and what
 * has happened (Security), what is wired to what and whether it runs (Integrations), the company and
 * its sites (Company), where the data lives and how a figure is worked out (Data), what the workspace
 * has and uses (Billing and usage), and who signed in and which roles changed (Admin log).
 *
 * **The section is the unit, never an item inside one.** The browser gate and the screen tests assert
 * each served section whole - heading, badge, summary, blocker, items, Open link - so a tab shows
 * complete sections or none. **A section the endpoint adds that is not named here falls to Company**
 * rather than disappearing: an omission on this screen reads as nothing being there to set. People and
 * roles, Billing and usage and the Admin log are screens of their own (a grid, the entitlements, the
 * event list), so no served section sits on them.
 */

export const ADMIN_TABS = [
  { key: "people", label: "People and roles" },
  { key: "routes", label: "Approval routes" },
  { key: "security", label: "Security" },
  { key: "integrations", label: "Integrations" },
  { key: "company", label: "Company" },
  { key: "data", label: "Data" },
  { key: "billing", label: "Billing and usage" },
  { key: "log", label: "Admin log" },
] as const;
export type AdminTabKey = (typeof ADMIN_TABS)[number]["key"];

/** The tabs that are a list of served sections (the others are screens of their own). */
export const SECTION_TABS: readonly AdminTabKey[] = ["routes", "security", "integrations", "company", "data"];

const TAB_OF_SECTION: Readonly<Record<string, AdminTabKey>> = {
  workspace: "company",
  people: "company",
  routes: "routes",
  identity: "security",
  audit: "security",
  governance: "data",
  methodology: "data",
  frameworks: "data",
  tagged_output: "data",
  integrations: "integrations",
};

export function adminTabOf(sectionKey: string): AdminTabKey {
  return TAB_OF_SECTION[sectionKey] ?? "company";
}
